module.exports = __webpack_public_path__ + "static/media/yunhaojingpin1.b2adba72.png";